import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';

// Gets if Focused Inbox feature is enabled for the user
export function isFocusedInboxEnabled(): boolean {
    return (
        getUserConfiguration().UserOptions.IsFocusedInboxFeatureSupported &&
        getUserConfiguration().UserOptions.IsFocusedInboxEnabled
    );
}

/**
 * Gets default FocusedViewFilter for selected folder
 * @param folderId of the folder
 */
export default function getDefaultFocusedViewFilterForSelectedFolder(
    folderId: string
): FocusedViewFilter {
    const distinguishedFolder = folderIdToName(folderId);
    if (distinguishedFolder !== 'inbox') {
        // None if folder is not Inbox
        return FocusedViewFilter.None;
    }

    if (!isFocusedInboxEnabled()) {
        // None if Focused Inbox feature is not enabled for user
        return FocusedViewFilter.None;
    }

    return FocusedViewFilter.Focused;
}
